import { render, staticRenderFns } from "./widgetTabs.vue?vue&type=template&id=6b9bc553&scoped=true"
import script from "./widgetTabs.vue?vue&type=script&lang=js"
export * from "./widgetTabs.vue?vue&type=script&lang=js"
import style0 from "./widgetTabs.vue?vue&type=style&index=0&id=6b9bc553&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9bc553",
  null
  
)

export default component.exports